import { render } from "./NotaFiscalPedidosCanceladosLiquidados.vue?vue&type=template&id=2ef80912&scoped=true"
import script from "./NotaFiscalPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./NotaFiscalPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./NotaFiscalPedidosCanceladosLiquidados.vue?vue&type=style&index=0&id=2ef80912&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef80912"]])

export default __exports__